import marcelo from '../assets/imgs/marcelo.jpg';
import alan from '../assets/imgs/alan.jpg';
import guilherme from '../assets/imgs/guilherme.jpg';
import mauro from '../assets/imgs/mauro.jpg';
import tiago from '../assets/imgs/tiago.jpg';
import eduardo from '../assets/imgs/eduardo.jpg';

export const depoimentos = [
  {
    nome: 'Marcelo Cavalcante',
    texto: 'Um curso com conteúdo direto, preciso e de fácil entendimento! Zona livre de queda e fator de queda é um conteúdo que pode ser complicado ao primeiro contato, mas fica de fácil compreensão com   a explicação do Willian Lacerda. Além de abordar também sobre o uso de equipamentos de protecao individual, equipamentos para trabalho e a parte normativa que abrange todo trabalho em altura.',
    imagem: marcelo,
  },
  {
    nome: 'Alan Anderson de Brito',
    texto: 'Parabéns mais uma vez! Tudo muito bem passado, didático e com um conteúdo importantíssimo. Gostei tanto que assisti duas vezes, não pelo certificado, mas pelo aprendizado. Quanto mais a gente vê pessoas explicando bem, melhor entendemos. Parabéns a você e ao GRUPO BIOSAFE!',
    imagem: alan,
  },
  {
    nome: 'Guilherme Sabattino',
    texto: 'O curso tá muito bom mesmo! É bem técnico, com a parte de cálculos e entendimento das diferenças, e eu gosto desse tipo de desafio. Pra mim, tá excelente!!',
    imagem: guilherme,
  },
  {
    nome: 'Mauro Santos',
    texto: 'O curso de Zona Livre de Queda (ZLQ) e Fator de Queda é um dos pilares da formação. Nele, o aluno desenvolve a capacidade técnica para calcular a ZLQ e compreender como o fator de queda influencia diretamente a segurança em trabalhos em altura.Trata-se de um conteúdo técnico e indispensável para quem busca excelência na área. No GRUPO BIOSAFE, esse curso é conduzido com qualidade, clareza e foco na prática, garantindo que cada profissional aplique esses conceitos com segurança e confiança no campo.',
    imagem: mauro,
  },
  {
    nome: 'Tiago Ribeiro',
    texto: 'Queria agradecer pelo curso de Fator de Queda e Zona Livre de Queda — finalmente consegui entender de forma clara como tudo funciona. Depois disso, consegui transmitir esse conhecimento de um jeito diferente pros meus treinamentos, e a compreensão ficou muito mais sólida. Parabéns pelo excelente trabalho! Valeu demais!',
    imagem: tiago,
  },
    {
    nome: 'Eduardo Reis',
    texto: 'Depois do curso de Fator de Queda e Zona Livre de Queda do GRUPO BIOSAFE, minha visão técnica mudou completamente. Passei a entender a importância desses conceitos na análise de risco e aplico isso no meu dia a dia e nos meus treinamentos. Um conteúdo essencial e transformador. Parabéns à equipe do GRUPO BIOSAFE.',
    imagem: eduardo,
  },
];
